import { useEffect } from "react";
import { useFetchSingleProjectQuery } from "../../utils/customer/customerTaskTable";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { getName } from "../../utils/utilityFunctions/stringUtility";
import expandButton from "../../assets/images/ExpandButton.svg";
import LoaderWrapper from "../UniversalComponents/CustomLoader";
const ProjectDetails = ({ projectId, setOpenAddProject }) => {
  const dispatch = useDispatch();

  const { data: projectDetailsData, isFetching } = useFetchSingleProjectQuery({ projectId });
  useEffect(() => {
    if (isFetching) {
      // dispatch(showLoader());
    } else {
      // dispatch(hideLoader());
    }
  }, [isFetching]);

  return (
    <div className="p-2 col-span-2 border border-[#D2DAE1] rounded-md w-full">
      {/* <LoaderWrapper isLoading={isFetching}> */}
      <table className="w-full">
        <tr>
          <td className="text-[#848687] font-300 text-xs">Customer Name</td>
          <td className="text-[#2C495D] font-400 text-sm">
            <span className="text-[#848687] font-300 text-xs mr-3">:</span>
          </td>
          <td className="text-[#2C495D] font-400 text-sm">{getName(projectDetailsData?.data?.customer_name)}</td>
          <td>
            <button type="button" onClick={() => setOpenAddProject("view")}>
              <img src={expandButton} />
            </button>
          </td>
        </tr>
        <tr>
          <td className="text-[#848687] font-300 text-xs">Project Name</td>
          <td className="text-[#2C495D] font-400 text-sm">
            <span className="text-[#848687] font-300 text-xs mr-3">:</span>
          </td>
          <td className="text-[#2C495D] font-400 text-sm">{getName(projectDetailsData?.data?.project_name)}</td>
        </tr>
        <tr>
          <td className="text-[#848687] font-300 text-xs">Software</td>
          <td className="text-[#2C495D] font-400 text-sm">
            <span className="text-[#848687] font-300 text-xs mr-3">:</span>
          </td>
          <td className="text-[#2C495D] font-400 text-sm">{getName(projectDetailsData?.data?.software)}</td>
        </tr>
      </table>
      {/* </LoaderWrapper> */}
    </div>
  );
};

export default ProjectDetails;
